export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            关于我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            了解68影院的初心与使命
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-8">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              68影院创立于2018年，是一个专注于高清电影免费在线观看的平台。我们致力于打造最全面的电影大全片库，让每一位影迷都能轻松找到自己想看的电影。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              从经典老片到最新上映的热门电影，从好莱坞商业大片到独立艺术佳作，68影院始终坚持以用户观影体验为核心。我们不断优化播放技术，确保高清画质和流畅不缓冲的在线观看体验。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              至今，68影院已累计服务超过千万影迷，片库总量突破50,000部。未来我们将持续扩充热门电影排行榜、丰富电影大全内容，成为你观影路上最可靠的伙伴。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}